import React from 'react';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Box } from '@mui/material';
import { formatNumber, formatMoeda } from '../../helpers/FormatValue';
import AttachMoneyOutlined from '@mui/icons-material/AttachMoneyOutlined';


const Totais = (props: { ipi: number; st: number; ii: number; totalItens: number, frete: number, totalPedido: number }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: 0,
        width: '100%',
        height: '100%',
        marginBottom: 3
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: -0.5, mb: 1 }}>
        <AttachMoneyOutlined sx={{ fontSize: 20, color: '#0965c1' }} />
        <Typography variant="subtitle1" fontSize='15px' fontWeight={500} sx={{ lineHeight: 1 }}>
          Totais
        </Typography>
      </Box>

      <Divider sx={{ width: '100%', marginBottom: 2, marginTop: -0.4 }} />

      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Typography variant="body2" fontSize='13px' fontWeight={500}>Itens:</Typography>
        <Typography variant="body2" fontSize='13px'>{formatMoeda(props.totalItens)}</Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Typography variant="body2" fontSize='13px' fontWeight={500}>IPI:</Typography>
        <Typography variant="body2" fontSize='13px'>{formatMoeda(props.ipi)}</Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Typography variant="body2" fontSize='13px' fontWeight={500}>ICMSST:</Typography>
        <Typography variant="body2" fontSize='13px' >{formatMoeda(props.st)}</Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Typography variant="body2" fontSize='13px' fontWeight={500}>Frete:</Typography>
        <Typography variant="body2" fontSize='13px'>{formatMoeda(props.frete)}</Typography>
      </Box>

      <Divider sx={{ width: '100%', marginBottom: 1, marginTop: 0.4 }} />

      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontWeight: 600, fontSize: '20px', textAlign: 'right', marginTop: 2 }}>
        <Typography variant="body2" fontSize='15px' fontWeight={500}>Total Pedido:</Typography>
        <Typography variant="body2" fontSize='15px'>{formatMoeda(props.totalPedido)}</Typography>
      </Box>
    </Box>
  );
};

export default Totais;